import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async syncClients({ commit }) {
      try {
        return await api.get('/chrons/clients')
      } catch (error) {
        throw error
      }
    },

    async createClient({ commit }, data) {
      try {
        return await api.post('/clients', data)
      } catch (error) {
        throw error
      }
    },

    async getClients({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/clients?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getClientsForLinkTickets({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/clients/link-tickets?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getClientsCode({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/clients/code?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getClient({ commit }, { clienteId, periodoId }) {
      try {
        const params = periodoId ? `?periodoId=${periodoId}` : ''

        const response = await api.get(`/clients/${clienteId}${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateClient({ commit }, data) {
      try {
        return await api.put(`/clients/${data.id}`, data.client)
      } catch (error) {
        throw error
      }
    },

    async finalizeClient({ commit }, data) {
      try {
        return await api.put(`/clients/${data.clienteId}/finalize`, data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
